import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownMenu,
  Button,
  Icon,
  MenuSection,
} from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { CalloutContext, IfPermission } from '@folio/stripes/core';

const ResultsActionsMenu = ({ handlePrint, toPDF, handleExcelExport, handleCsvExport }) => {
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const callout = useContext(CalloutContext);
  const intl    = useIntl();

  const toggleDropdown = () => {
    setdropdownOpen(!dropdownOpen);
  };

  const getDropdownContent = () => {
    return (
      <>
        <MenuSection>
          <IfPermission perm="ui-reports.reports.export">
            <Button
              marginBottom0
              id="results-actions-export-excel-btn"
              buttonStyle="dropdownItem"
              onClick={() => {
                if (!handleExcelExport) {
                  callout.sendCallout({
                    message: intl.formatMessage({
                      id: 'ui-reports.export.saveReportFirst',
                      defaultMessage: 'Please save the report first before exporting.',
                    }),
                    type: 'warning',
                  });
                } else {
                  handleExcelExport();
                }
                toggleDropdown();
              }}
              onMouseDown={(e) => e.preventDefault()}
            >
              <Icon icon="download">
                <FormattedMessage
                  id="ui-reports.resultsActions.exportExcel"
                  defaultMessage="Export to Excel"
                />
              </Icon>
            </Button>
            <Button
              marginBottom0
              id="results-actions-export-csv-btn"
              buttonStyle="dropdownItem"
              onClick={() => {
                if (!handleCsvExport) {
                  callout.sendCallout({
                    message: intl.formatMessage({
                      id: 'ui-reports.export.saveReportFirst',
                      defaultMessage: 'Please save the report first before exporting.',
                    }),
                    type: 'warning',
                  });
                } else {
                  handleCsvExport();
                }
                toggleDropdown();
              }}
              onMouseDown={(e) => e.preventDefault()}
            >
              <Icon icon="download">
                <FormattedMessage
                  id="ui-reports.resultsActions.exportCSV"
                  defaultMessage="Export to CSV"
                />
              </Icon>
            </Button>
            <Button
              marginBottom0
              id="results-actions-export-pdf-btn"
              buttonStyle="dropdownItem"
              onClick={() => {
                toPDF();
                toggleDropdown();
              }}
              onMouseDown={(e) => e.preventDefault()}
              disabled={!toPDF}
            >
              <Icon icon="source">
                <FormattedMessage
                  id="ui-reports.resultsActions.exportPDF"
                  defaultMessage="Export to PDF"
                />
              </Icon>
            </Button>
          </IfPermission>
        </MenuSection>
        <hr />
        <MenuSection>
          <Button
            marginBottom0
            id="results-actions-print-btn"
            buttonStyle="dropdownItem"
            onClick={() => {
              handlePrint();
              toggleDropdown();
            }}
            onMouseDown={(e) => e.preventDefault()}
            disabled={!handlePrint}
          >
            <Icon icon="print">
              <FormattedMessage
                id="ui-reports.resultsActions.print"
                defaultMessage="Print report"
              />
            </Icon>
          </Button>
        </MenuSection>
      </>
    );
  };

  const renderActionsMenuTrigger = ({ getTriggerProps, open }) => {
    return (
      <FormattedMessage id="ui-reports.resultsActions.menuLabel">
        {(label) => (
          <div style={{ paddingRight: '0.25em', paddingLeft: '0.25em' }}>
            <Button
              data-test-pane-header-actions-button
              buttonStyle="primary"
              marginBottom0
              ariaLabel={label}
              type="button"
              {...getTriggerProps()}
            >
              <Icon icon="ellipsis" size="large" />
            </Button>
          </div>
        )}
      </FormattedMessage>
    );
  };

  const renderActionsMenu = ({ open }) => (
    <DropdownMenu open={open}>{getDropdownContent()}</DropdownMenu>
  );

  return (
    <Dropdown
      id="ui-translation-actionsMenu-Dropdown"
      renderTrigger={renderActionsMenuTrigger}
      renderMenu={renderActionsMenu}
      open={dropdownOpen}
      onToggle={toggleDropdown}
      placement="bottom-end"
      relativePosition
      focusHandlers={{ open: () => null }}
    />
  );
};

ResultsActionsMenu.propTypes = {
  handlePrint:       PropTypes.func,
  toPDF:             PropTypes.func,
  handleExcelExport: PropTypes.func,
  handleCsvExport:   PropTypes.func,
};

export default ResultsActionsMenu;
